import { render, staticRenderFns } from "./Scenicspot.vue?vue&type=template&id=6115964b&scoped=true"
import script from "./Scenicspot.vue?vue&type=script&lang=js"
export * from "./Scenicspot.vue?vue&type=script&lang=js"
import style0 from "./Scenicspot.vue?vue&type=style&index=0&id=6115964b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6115964b",
  null
  
)

export default component.exports